import { capitalize } from 'lodash-es'

import type { Workflow } from '@fv/models'

export const displayWorkflow = (workflow: Workflow) => {
  if (workflow === 'ltl') return 'LTL'

  return capitalize(workflow)
}
